{
  "columns": {
    "status": "Статус",
    "resource_type": "Сущность",
    "actions_conflict": "Действие при конфликте",
    "message": "Сообщение"
  },
  "statuses": {
    "new": "Новый",
    "success": "Успешно",
    "skipped": "Пропущено",
    "conflict": "Конфликт",
    "error": "Ошибка"
  },
  "controls": {
    "nextStage": "Вперед",
    "prevStage": "Назад",
    "reset": "Сброс"
  },
  "states": {
    "idle": "Ожидание ввода",
    "success": "Успешно",
    "warning": "Предупреждение",
    "loading": "Загрузка...",
    "error": "Ошибка импорта",
    "importedWithErrors": "Импортировано с ошибками",
    "userActionRequired": "Необходимо выполнить пользовательское действие"
  },
  "stages": {
    "analyze": "Анализ",
    "result": "Результат"
  },
  "messages": {
    "common_action": "Выберите общее действие",
    "placeholder": "Новое имя",
    "conflict_actions": {
      "replace": "Ресурс успешно обновлен",
      "rename": "Ресурс успешно переименован",
      "success": "Ресурс успешно создан",
      "error": "Произошла неизвестная ошибка",
      "skipped": "Импорт пропущен пользователем",
      "canceled": "Импорт отменен"
    },
    "options": {
      "skip": "Пропустить действие",
      "replace": "Заменить существующий",
      "rename": "Переименовать"
    }
  }
}